/**
 * Add class to parent group-block div for primary-product-card elements
 */

(function() {
  function addClassToPrimaryProductCardParents() {
    // Find all elements with class 'primary-product-card'
    const primaryProductCards = document.querySelectorAll('.primary-product-card');
    
    primaryProductCards.forEach(card => {
      // Find the parent div with class 'group-block'
      const parentGroupBlock = card.closest('.group-block');
      
      if (parentGroupBlock) {
        // Add a class to the parent group-block div
        // You can change 'primary-product-card-parent' to any class name you want
        parentGroupBlock.classList.add('primary-product-card-parent');
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addClassToPrimaryProductCardParents);
  } else {
    addClassToPrimaryProductCardParents();
  }

  // Also run when content is dynamically loaded (for Shopify theme editor)
  if (document.addEventListener) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(addClassToPrimaryProductCardParents, 100);
    });
    
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(addClassToPrimaryProductCardParents, 100);
    });
  }
})();
